import { PayoutState, PayoutDetailResultType } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';

export const PAYOUT_STATE_TEXT_KEY_MAP = {
    [PayoutState.Pending]: TextKey.PayoutInProcessState,
    [PayoutState.Paid]: TextKey.Paid,
    [PayoutState.Failed]: TextKey.Failed,
};

export const PAYOUT_TRANSACTION_TYPE_TEXT_KEY_MAP: Record<PayoutDetailResultType, Mews.TextKey> = {
    [PayoutDetailResultType.Charge]: TextKey.MerchantBalanceTransactionTypeCharge,
    [PayoutDetailResultType.CommissionAdjustment]: TextKey.MerchantBalanceTransactionTypeCommissionAdjustment,
    [PayoutDetailResultType.Refund]: TextKey.Refund,
    [PayoutDetailResultType.ChargeBack]: TextKey.Chargeback,
    [PayoutDetailResultType.ChargebackReversal]: TextKey.PayoutChargebackReversal,
    [PayoutDetailResultType.PlatformFee]: TextKey.MerchantBalanceTransactionTypePlatformFee,
    [PayoutDetailResultType.BalanceTopUp]: TextKey.MerchantBalanceTransactionTypeBalanceTopUp,
    [PayoutDetailResultType.Payout]: TextKey.MerchantBalanceTransactionTypePayout,
};
